/** @jsxImportSource @emotion/react */

import { createStyles } from '@quickbit/qb-design-system';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const Header = ({ children }: Props) => {
  const styles = useStyles();
  return <div css={styles.default}>{children}</div>;
};

const useStyles = createStyles(({ spacing, palette }) => ({
  default: {
    position: 'sticky',
    top: 0,
    zIndex: 99,
    padding: spacing.xxs,
    background: palette.white,
    width: '100%',
    marginBottom: spacing.xs,
    borderRadius: spacing.xxxs,
    border: `1px solid ${palette.grey.x100}`,
  },
}));
